<template>
  <router-view />
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      loginState: "loginState"
    })
  },
  async mounted() {
    if (!this.loginState) {
      this.$router.push({ name: "home" });
    }
  }
};
</script>
